import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Efficiency: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[1.5px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 22.0002H15C20 22.0002 22 20.0002 22 15.0002V9.00024C22 4.00024 20 2.00024 15 2.00024H9C4 2.00024 2 4.00024 2 9.00024V15.0002C2 20.0002 4 22.0002 9 22.0002Z"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33008 14.4902L9.71008 11.4002C10.0501 10.9602 10.6801 10.8802 11.1201 11.2202L12.9501 12.6602C13.3901 13.0002 14.0201 12.9202 14.3601 12.4902L16.6701 9.51025"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Efficiency;
